import React from "react"

import {FieldGlistGroupProps} from "../../../../render/glist/glist-group"
import FieldRAG_GlistGroupModern from "./modern";

export default function FieldRAG_GlistGroupStandard(props:FieldGlistGroupProps) {

    // const option = this._getOption(value);
    const option = props.field._getOption(props.data.value)

    const groupName = _.get(option,'label', props.field.noValueOptionLabel)

    const ragValue = typeof option.value === 'string' ? parseInt(option.value) : option.value

    const ragClasses = Classes("ui5-ico-rag m-r-10", {
        'red'   : ragValue === 0,
        'amber' : ragValue === 1,
        'green' : ragValue === 2,
    })

    return (
        <div className="group-cards">
            <div className={ragClasses}/>
            <div className="text">{groupName}</div>
            {!!props.data.isCollapsed && <div className="counter">{props.data.counter}</div>}

            {!props.data.isCollapsed &&
                <div className="group-corners">
                    <div className="top-corner"/>
                </div>}
        </div>
    )
}
